export default "__VITE_ASSET__IX0z5E5y__"